import { Box, Divider, List, ListItemButton, ListItemText, ListItemTextProps, styled, Typography } from '@mui/material'

export const SidebarDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.sidebar.divider,
  opacity: 0.72,
}))

export const SidebarList = styled(List)(() => ({
  margin: '0px 12px',
  gap: 8,
  display: 'flex',
  flexDirection: 'column',
}))

export const SidebarSubList = styled(List)(() => ({
  padding: 0,
  gap: 12,
  display: 'flex',
  flexDirection: 'column',
}))

export const SidebarBadge = styled(Box)(({ theme }) => ({
  background: theme.palette.neutralLight[900],
  color: theme.palette.neutralLight[0],
  borderRadius: 10,
  padding: '1px 7px',
  fontSize: 10,
}))

export const SidebarItemWrapper = styled(Box)(() => ({
  margin: '0px 14px',
  gap: 12,
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 8,
}))

export const SidebarListItemText = (props: ListItemTextProps) => (
  <ListItemText
    {...props}
    sx={{
      my: 0,
    }}
    slotProps={{
      primary: { color: 'sidebar.text', variant: 'HeaderSubtitleMediumRegular' },
    }}
  />
)

export const SidebarListItemSubText = (props: ListItemTextProps) => (
  <ListItemText
    {...props}
    slotProps={{
      primary: { color: 'sidebar.secondaryText', variant: 'HeaderSubtitleMediumRegular' },
    }}
  />
)

export const SidebarListItemButton = styled(ListItemButton)(({ theme }) => ({
  color: theme.palette.sidebar.text,
  padding: '4px 12px',
  minHeight: 28,
  cursor: 'pointer',
  borderRadius: 8,
  '&.Mui-selected': { backgroundColor: theme.palette.sidebar.selectedBackground },
  ':hover': { backgroundColor: theme.palette.sidebar.hoverBackground },
}))

export const SidebarListItemSubButton = styled(ListItemButton)(({ theme }) => ({
  color: theme.palette.sidebar.secondaryText,
  p: 0,
  height: 29,
  cursor: 'pointer',
  borderRadius: 4,
  paddingLeft: 12,
  marginLeft: 36,
  '&.Mui-selected': { backgroundColor: theme.palette.sidebar.selectedBackground },
  ':hover': { backgroundColor: theme.palette.sidebar.hoverBackground },
}))

export const SidebarSectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Typography
    variant="Body14pxRegular"
    sx={{
      px: 6,
      mb: 1,
      color: 'text.secondary',
    }}
  >
    {children}
  </Typography>
)
